import React from 'react';
import { Helmet } from 'react-helmet-async';

const CookiePolicy = () => {
  return (
    <>
      <div className="h-28"></div> {/* Dedicated spacer */}
      <div className="container mx-auto px-4 py-12">
        <Helmet>
          <title>Cookie Policy - ZiwaTech</title>
          <meta name="description" content="ZiwaTech's cookie policy explains how we use cookies and similar technologies on our website." />
        </Helmet>

        <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-primary">
          <i className="fa-solid fa-cookie-bite mr-2"></i>
          Cookie Policy
        </h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="mb-4">Last Updated: May 22, 2025</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">What Are Cookies</h2>
            <p>
              Cookies are small pieces of text sent by your web browser by a website you visit. A cookie file is stored 
              in your web browser and allows the website or a third-party to recognize you and make your next visit easier 
              and the website more useful to you.
            </p>
            <p className="mt-4">
              Cookies can be "persistent" or "session" cookies. Persistent cookies remain on your personal computer or 
              mobile device when you go offline, while session cookies are deleted as soon as you close your web browser.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">How ZiwaTech Uses Cookies</h2>
            <p className="mb-4">
              When you use and access our website, we may place a number of cookie files in your web browser. 
              We use cookies for the following purposes:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Essential cookies:</strong> These are cookies that are required for the operation of our website. They include, for example, cookies that enable you to log into secure areas of our website or use a shopping cart.</li>
              <li><strong>Analytical/performance cookies:</strong> They allow us to recognize and count the number of visitors and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily.</li>
              <li><strong>Functionality cookies:</strong> These are used to recognize you when you return to our website. This enables us to personalize our content for you, greet you by name and remember your preferences (for example, your choice of language or region).</li>
              <li><strong>Targeting cookies:</strong> These cookies record your visit to our website, the pages you have visited and the links you have followed. We will use this information to make our website and the advertising displayed on it more relevant to your interests.</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Third-Party Cookies</h2>
            <p>
              In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the 
              website, deliver advertisements on and through the website, and so on. These may include cookies from:
            </p>
            <ul className="list-disc pl-6 mt-4">
              <li>Google Analytics</li>
              <li>Facebook</li>
              <li>Twitter</li>
              <li>Other social media platforms</li>
              <li>Advertising partners</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">What Are Your Choices Regarding Cookies</h2>
            <p className="mb-4">
              If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help 
              pages of your web browser.
            </p>
            <p className="mb-4">
              Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the 
              features we offer, you may not be able to store your preferences, and some of our pages might not display properly.
            </p>
            <p>
              You can learn more about cookies and the following third-party websites:
            </p>
            <ul className="list-disc pl-6 mt-4">
              <li>AllAboutCookies: <a href="http://www.allaboutcookies.org/" className="text-primary hover:underline">http://www.allaboutcookies.org/</a></li>
              <li>Network Advertising Initiative: <a href="http://www.networkadvertising.org/" className="text-primary hover:underline">http://www.networkadvertising.org/</a></li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Changes to This Cookie Policy</h2>
            <p>
              We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new 
              Cookie Policy on this page. You are advised to review this Cookie Policy periodically for any changes.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
            <p>
              If you have any questions about our Cookie Policy, please contact us at:
              <br />
              Email: privacy@ziwatech.ca
              <br />
              Phone: +1647-200-2040
              <br />
              Address: A140-1 York Gate Blvd, North York, Toronto, ON M3N 3A1, Canada
            </p>
          </section>
        </div>
      </div>
      </div>
    </>
  );
};

export default CookiePolicy;
